<template>
  <div>
    <div class="d-flex justify-content-center align-items-center min-vh-100">
      <b-card class="w-75">
        <div class="text-center">
          <h3 class="my-2">{{ formatTime(timer) }}</h3>
        </div>
        <h1 class="text-center my-4">Test Materi Profesi Psikologi</h1>
        <div class="question-container" v-if="reloadCardNonExist == 0">
          <b-form-group v-if="pertanyaans[activeTab]">
          <center>
            <b-img style="max-width: 300px;" v-if="pertanyaans[activeTab].gambar != null" :src="pertanyaans[activeTab].gambar" fluid alt="Fluid image"></b-img>
          </center>
          <br>
          <br>
          <div class="ml-5 mr-5">
            <h5>{{ activeTab + 1 }}. {{ pertanyaans[activeTab].soal }}</h5>
            <b-row>
              <b-col cols="12" v-for="option in pertanyaans[activeTab].pilihan_jawaban" :key="option.uuid">
                <b-form-radio v-model="pertanyaans[activeTab].pilihan_jawaban_uuid" @change="handleRadioChange(pertanyaans[activeTab].uuid, option.uuid)" :value="option.uuid">
                  {{ option.pilihan_jawaban }}
                </b-form-radio>
              </b-col>
            </b-row>
          </div>
          </b-form-group>
        </div>
        <br>
        <div class="navigation-buttons ml-5 mr-5">
          <b-button variant="primary" @click="previousQuestion" :disabled="activeTab === 0">Back</b-button>
          <b-button variant="primary" @click="nextQuestion" :disabled="activeTab === pertanyaans.length - 1" v-if="activeTab != pertanyaans.length - 1">Next</b-button>
          <b-button variant="success" v-else @click="submitForm">Submit</b-button>
        </div>
      <div class="container">
        <div class="mt-3 mr-5 ml-5">
          <b-row>
            <b-col lg="1" class="pb-2" v-for="(pertanyaan, index) in pertanyaans" :key="index">
              <b-button class="mb-1" size="sm" style="margin-right: 2px;" @click="activeTab = index" :variant="isAnswered(index) ? 'success' : 'secondary'">
                {{ index + 1 }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BFormGroup,
  BFormRadio,
  BRow,
  BImg,
} from 'bootstrap-vue';
import {
  getAllQuestion,
  postJawaban,
  submitUjian
} from '@/connection-api/kompetensidasar'
import router from '@/router'

export default {
  components: {
    BButton,
    BButtonGroup,
    BCard,
    BCol,
    BFormGroup,
    BFormRadio,
    BRow,
    BImg,
  },
  data() {
    return {
      activeTab: 0,
      pertanyaans: [],
      reloadCard: 0,
      reloadCardNonExist: 0,
      timer: 0,
    };
  },
  created() {
    this.getToken();
  },
  methods: {
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    },
    timeUp() {
      this.reloadCardNonExist = this.reloadCardNonExist + 1;
      this.$bvModal.msgBoxOk('Waktu Ujian Telah Berakhir, Anda Dapat Mengunjungi Website Simak UI Untuk Melihat Status Kelulusan', {
        title: 'Ujian Telah Berakhir',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false
      }).then(value => {
        setTimeout(() => {
        this.$router.push({name: "dashboard-users"});
      }, 5000);
      });
     
      // Handle the end of the exam (e.g., auto-submit, navigate away, etc.)
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.timerInterval);
          this.timeUp();
        }
      }, 1000);
    },
    async submitForm(){
      if(window.confirm('Apakah anda yakin ingin menyelesaikan ujian? Periksa kembali jawaban anda karena jika klik submit anda tidak dapat kembali ke halaman ujian')) {
        this.$bvModal.msgBoxOk('Waktu Ujian Telah Berakhir, Anda Dapat Mengunjungi Website Simak UI Untuk Melihat Status Kelulusan', {
        title: 'Ujian Telah Berakhir',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false
      }).then(value => {
        const token_ujian = router.currentRoute.params.token_ujian;
        const response = submitUjian(token_ujian);
        setTimeout(() => {
        this.$router.push({name: "dashboard-users"});
      }, 5000);
      });
      }
    },
    async getToken() {
      const token_ujian = router.currentRoute.params.token_ujian;
      const response = await getAllQuestion(token_ujian);
      if(response.data){
        if(response.data.status.code === '00'){
          this.pertanyaans = response.data.data.all_question;
          this.reloadCard = this.reloadCard + 1;
          this.timer = response.data.data.timer
          this.startTimer();
        }else{
          this.reloadCardNonExist = this.reloadCardNonExist + 1;
          this.startTimer();
        }
      }
    },
    async handleRadioChange(uuid, value) {
      const data = {
        token_ujian: router.currentRoute.params.token_ujian,
        uuid: uuid,
        pilihan_jawaban_uuid: value
      }
      const response = await postJawaban(data);
    },
    nextQuestion() {
      if (this.activeTab < this.pertanyaans.length - 1) {
        this.activeTab++;
      }
    },
    previousQuestion() {
      if (this.activeTab > 0) {
        this.activeTab--;
      }
    },
    isAnswered(index) {
      return this.pertanyaans[index].pilihan_jawaban_uuid !== null;
    },
  },
};
</script>

<style>
.question-container {
  margin-bottom: 1rem;
}
.navigation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}
.answered {
  background-color: #28a745;
  color: white;
}
.min-vh-100 {
  min-height: 100vh;
}
.question-navigation {
  max-width: 100%;
}
</style>
